import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { ContentService } from '../shared/content.service';
import { Content } from '../shared/content';
import { ConfigService } from '../shared/config.service';
import { UtilsService } from '../shared/utils.service';
import { MetaService } from '../shared/meta.service';
import { NotificationService } from '../shared/notification.service';
import { IntlService } from '../shared/intl.service';

@Component({
    template: require('./partials/content-special-edit.component.html'),
    providers: [DatePipe]
})
export class ContentSpecialEditComponent extends Content implements OnInit {// 

    public action: string = 'add';
    specialForm: FormGroup;
    recordUrl: string;
    image: string;

    constructor(public specialConfig: ConfigService, private specialIntlService: IntlService, private datePipe: DatePipe, private notification: NotificationService, private metaSpecialService: MetaService, private utils: UtilsService, private formBuilder: FormBuilder, private router: Router, private specialService: ContentService, private specialRoute: ActivatedRoute) {
        super(specialConfig, specialIntlService, metaSpecialService, specialService, specialRoute);
        this.setType('special');
    }

    ngOnInit() {

        this.specialRoute.params.subscribe((params: Params) => {

            // Get record url
            this.specialRoute.queryParams.subscribe((queryParams: Params) => {

                this.recordUrl = queryParams['recordUrl'];

                // Need to init the form for the view, for some reason
                let group = this.buildGroupForm(true,{});
                this.specialForm = this.formBuilder.group(group);

                if(params['id']!=0) {
                    this.action='update';
                    this.specialService.getContent(this.type, {_id: params['id']}, true).then(response => {
                        this.content = response;
                        let group = this.buildGroupForm(false,this.content);
                        this.specialForm = this.formBuilder.group(group);
                        this.image = this.content.image;
                    });
                } else {
                    // Get record info (no cache)
                    this.specialService.getContent('record',{url: this.recordUrl}, true).then(record => {
                        this.specialForm.controls['url'].setValue(record.url);
                        this.image = '/' + this.specialConfig.data.DATA.covers + '/thumbs/' + record.cover.front;
                        this.specialForm.controls['image'].setValue(this.image);
                    });
                }

            });
            
        });

        this.specialRoute.parent.params.subscribe((params: Params) => {
            // Current language
            this.currentLanguage = params['lg'];
        });

    }

    buildGroupForm(isNew: boolean, content: any){
        let group = {};
        if(!isNew) 
            group['_id'] = content._id;
        group['active'] = [isNew ? false : content.active,[]]; // not active when new
        group['image'] = [content.image,[]];
        group['url'] = [content.url,[
            Validators.required
        ]];
        group['date'] = [this.datePipe.transform(isNew ? new Date() : content.date, 'yyyy-MM-dd'),[]];
        group['update_date'] = [isNew ? null : this.datePipe.transform(content.update_date, 'yyyy-MM-dd'),[]];
        group['title'] = isNew ? 
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.title);
        group['subtitle'] = isNew ? 
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.subtitle);
        group['content'] = isNew ? 
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.content);
        return group;
    }

    onSubmit() {
        // update date
        this.specialForm.controls['update_date'].setValue(Date.now());
        // save
        this.specialService.saveContent('special', this.action, this.specialForm.value).then(res => {
            // this.notification.notify(res);
            this.router.navigate(['specials'], { relativeTo: this.route.parent });
        })
    }

    public deleteContent(type: string, id: string){ 
        this.specialService.deleteContent(type,id);
        this.router.navigate(['specials/reload'], {relativeTo: this.route.parent});
        setTimeout(() => {
            this.router.navigate(['specials'], {relativeTo: this.route.parent});
        }, 500);  
    }

} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-special-edit.component.ts